import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 12 12",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "m3.968 7.851-.005.005L5.2 9.094l4.95-4.95-1.238-1.238-3.707 3.708-2.117-2.118L1.85 5.734z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }